import { z } from "zod";

/**
 * Student Group Schema - กลุ่มนักเรียน
 */
export const StudentGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  description: z.string().nullable(),
  order: z.number().int().nullable(),
  status: z.enum(["active", "inactive"]),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type StudentGroupDTO = z.infer<typeof StudentGroupSchema>;

/**
 * Create Student Group Schema
 */
export const CreateStudentGroupSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ"),
  code: z
    .string()
    .min(1, "Code ຕ້ອງບໍ່ວ່າງ")
    .regex(/^[A-Z0-9_-]+$/, "Code ຕ້ອງເປັນຕົວອັກສອນໃຫຍ່, ຕົວເລກ, _ ຫຼື - ເທົ່ານັ້ນ"),
  description: z.string().nullable().optional(),
  order: z.number().int().nullable().optional(),
  status: z.enum(["active", "inactive"]).default("active"),
});
export type CreateStudentGroupDTO = z.infer<typeof CreateStudentGroupSchema>;

/**
 * Update Student Group Schema
 */
export const UpdateStudentGroupSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ").optional(),
  code: z
    .string()
    .min(1, "Code ຕ້ອງບໍ່ວ່າງ")
    .regex(/^[A-Z0-9_-]+$/, "Code ຕ້ອງເປັນຕົວອັກສອນໃຫຍ່, ຕົວເລກ, _ ຫຼື - ເທົ່ານັ້ນ")
    .optional(),
  description: z.string().nullable().optional(),
  order: z.number().int().nullable().optional(),
  status: z.enum(["active", "inactive"]).optional(),
});
export type UpdateStudentGroupDTO = z.infer<typeof UpdateStudentGroupSchema>;

/**
 * Reorder Student Groups Schema
 */
export const ReorderStudentGroupsSchema = z.object({
  groupIds: z.array(z.string()).min(1, "ຕ້ອງມີຢ່າງໜ້ອຍ 1 ກຸ່ມ"),
});
export type ReorderStudentGroupsDTO = z.infer<
  typeof ReorderStudentGroupsSchema
>;
